import { render, staticRenderFns } from "./KomlabsRegistrationForm.vue?vue&type=template&id=10d5f43c&"
import script from "./KomlabsRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./KomlabsRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports